import TableComponent, { IColumnProps } from '../../components/TableComponent';
import React, { useContext, useEffect, useState } from 'react';
import { LockReset, Route, Shield, Webhook, Mail, Home } from '@mui/icons-material';
import { Badge as MuiBadge } from '@mui/material';
import ButtonComponent from '../../components/ButtonComponent';
import { useGetAllIntegrationsByLicenseAsync } from '../../services/IntegrationService/hooks/useMutation';
import IntegrationEditModal from './_components/IntegrationEditModal';
import ButtonActionsComponent from '../../components/ButtonActionsComponent';
import ConfirmDeleteModalComponent from '../../components/ConfirmDeleteModalComponent';
import {
  IIntegrationProps,
  IntegrationDiscriminator,
} from '../../services/IntegrationService/types';
import { AppContext } from '../../context/AppContextProvider';
import IconImageComponent from '../../components/IconImageComponent';
import cigam_icon from '../../assets/images/icons/integrations/cigam_icon.webp';
import moni_icon from '../../assets/images/icons/integrations/moni_icon.webp';
import activesoft_icon from '../../assets/images/icons/integrations/activesoft_icon.webp';
import sigma_icon from '../../assets/images/icons/integrations/sigma_icon.webp';
import tuya_icon from '../../assets/images/icons/integrations/tuya_icon.webp';
import totvs_logo from '../../assets/images/icons/integrations/totvs_logo.webp';
import moovsec_icon from '../../assets/images/icons/integrations/moovsec_icon.webp';
import classapp_icon from '../../assets/images/icons/integrations/classapp_icon.svg';
import gvdasa_icon from '../../assets/images/icons/integrations/gvdasa_icon.webp';
import sponte_icon from '../../assets/images/icons/integrations/sponte_icon.webp';
import escolaweb_icon from '../../assets/images/icons/integrations/escolaweb_icon.webp';
import escolarmanager_icon from '../../assets/images/icons/integrations/escolarmanager_icon.webp';
import clipescola_icon from '../../assets/images/icons/integrations/clipescola_icon.webp';
import sophia_icon from '../../assets/images/icons/integrations/sophia_icon.webp';
import sevenedu_icon from '../../assets/images/icons/integrations/sevenedu_icon.webp';
import { useDeleteSurgardIntegrationAsync } from '../../services/IntegrationService/SurgardService/hooks/useMutation';
import { useDeleteWebhookIntegrationAsync } from '../../services/IntegrationService/WebhookService/hooks/useMutation';
import { useDeleteMoniIntegrationAsync } from '../../services/IntegrationService/MoniService/hooks/useMutation';
import { useDeleteDefenseIntegration } from '../../services/IntegrationService/DefenseService/hooks/useMutations';
import { useDeleteSigmaIntegrationAsync } from '../../services/IntegrationService/SigmaService/hooks/useMutation';
import { useDeleteDefenseBridgeAsync } from '../../services/Defense/Bridge/hooks/useMutations';
import HeaderDashboard from 'pages/DashboardPageClient/_components/_ui/Header';
import { t } from 'i18next';
import { useDeleteClassAppIntegrationAsync } from '../../services/IntegrationService/ClassAppService/hooks/useMutation';
import { useDeleteGvdasaIntegrationAsync } from '../../services/IntegrationService/GvdasaService/hooks/useMutation';
import { useDeleteActiveSoftIntegrationAsync } from '../../services/IntegrationService/ActiveSoftService/hooks/useMutation';
import { useDeleteSmtpIntegrationAsync } from '../../services/IntegrationService/SmtpService/hooks/useMutation';
import { useDeleteClipEscolaIntegrationAsync } from '../../services/IntegrationService/ClipEscolaService/hooks/useMutation';
import { useDeleteSophiaIntegrationAsync } from '../../services/IntegrationService/SophiaService/hooks/useMutation';
import { useDeleteCigamIntegrationAsync } from 'services/IntegrationService/CigamService/hooks/useMutation';
import { useDeleteTuyaIntegrationAsync } from 'services/IntegrationService/TuyaService/hooks/useMutation';
import { useDeleteTotvsIntegrationAsync } from 'services/IntegrationService/TotvsService/hooks/useMutation';
import { useDeleteHomeAssistantIntegrationAsync } from 'services/IntegrationService/HomeAssistantService/hooks/useMutation';
import { useDeleteTotvsIENHIntegrationAsync } from '../../services/IntegrationService/TotvsIENHService/hooks/useMutation';
import { useDeleteMoovsecIntegrationAsync } from '../../services/IntegrationService/MoovsecService/hooks/useMutation';
import { useDeleteSevenEduIntegrationAsync } from '../../services/IntegrationService/SevenEduService/hooks/useMutation';
import { useDeleteSponteIntegrationAsync } from '../../services/IntegrationService/SponteService/hooks/useMutation';
import { useDeleteEscolaWebIntegrationAsync } from '../../services/IntegrationService/EscolaWebService/hooks/useMutation';
import { useDeleteEscolarManagerIntegrationAsync } from '../../services/IntegrationService/EscolarManagerService/hooks/useMutation';

function IntegrationPage() {
  const { showSnackbar } = useContext(AppContext);
  const [integrations, setIntegrations] = useState<IIntegrationProps[]>([]);
  const [isVisibleDeleteItemModal, setIsVisibleDeleteItemModal] =
    useState<boolean>(false);
  const [isVisibleEditionModal, setIsVisibleEditionModal] =
    useState<boolean>(false);
  const [integrationEditModalKey, setIntegrationEditModalKey] = useState(0);
  const [selectedItem, setSelectedItem] = useState<IIntegrationProps>();

  const { mutateAsync: mutateGetAllIntegrationsByLicenseAsync } =
    useGetAllIntegrationsByLicenseAsync();
  const {
    mutateAsync: mutateDeleteSurgardIntegrationAsync,
    isLoading: isLoadingDeleteSurgardIntegrationAsync,
  } = useDeleteSurgardIntegrationAsync();
  const {
    mutateAsync: mutateDeleteWebhookIntegrationAsync,
    isLoading: isLoadingDeleteWebhookIntegrationAsync,
  } = useDeleteWebhookIntegrationAsync();
  const {
    mutateAsync: mutateDeleteMoniIntegrationAsync,
    isLoading: isLoadingDeleteMoniIntegrationAsync,
  } = useDeleteMoniIntegrationAsync();
  const {
    mutateAsync: mutateDeleteDefenseIntegrationAsync,
    isLoading: isLoadingDeleteDefenseIntegrationAsync,
  } = useDeleteDefenseIntegration();
  const {
    mutateAsync: mutateDeleteSigmaIntegrationAsync,
    isLoading: isLoadingDeleteSigmaIntegrationAsync,
  } = useDeleteSigmaIntegrationAsync();
  const {
    mutateAsync: mutateDeleteDefenseBridgeIntegrationAsync,
    isLoading: isLoadingDeleteDefenseBridgeIntegrationAsync,
  } = useDeleteDefenseBridgeAsync();
  const {
    mutateAsync: mutateDeleteClassAppIntegrationAsync,
    isLoading: isLoadingDeleteClassAppIntegrationAsync,
  } = useDeleteClassAppIntegrationAsync();
  const {
    mutateAsync: mutateDeleteTotvsIENHIntegrationAsync,
    isLoading: isLoadingDeleteTotvsIENHIntegrationAsync,
  } = useDeleteTotvsIENHIntegrationAsync();
  const {
    mutateAsync: mutateDeleteGvdasaIntegrationAsync,
    isLoading: isLoadingDeleteGvdasaIntegrationAsync,
  } = useDeleteGvdasaIntegrationAsync();
  const {
    mutateAsync: mutateDeleteActiveSoftIntegrationAsync,
    isLoading: isLoadingDeleteActiveSoftIntegrationAsync,
  } = useDeleteActiveSoftIntegrationAsync();
  const {
    mutateAsync: mutateDeleteSmtpIntegrationAsync,
    isLoading: isLoadingDeleteSmtpIntegrationAsync,
  } = useDeleteSmtpIntegrationAsync();
  const {
    mutateAsync: mutateDeleteClipEscolaIntegrationAsync,
    isLoading: isLoadingDeleteClipEscolaIntegrationAsync,
  } = useDeleteClipEscolaIntegrationAsync();
  const {
    mutateAsync: mutateDeleteSophiaIntegrationAsync,
    isLoading: isLoadingDeleteSophiaIntegrationAsync,
  } = useDeleteSophiaIntegrationAsync()
  const {
    mutateAsync: mutateDeleteCigamIntegrationAsync,
    isLoading: isLoadingDeleteCigamIntegrationAsync,
  } = useDeleteCigamIntegrationAsync()
  const {
    mutateAsync: mutateDeleteTuyaIntegrationAsync,
    isLoading: isLoadingDeleteTuyaIntegrationAsync,
  } = useDeleteTuyaIntegrationAsync()
  const {
    mutateAsync: mutateDeleteTotvsIntegrationAsync,
    isLoading: isLoadingDeleteTotvsIntegrationAsync,
  } = useDeleteTotvsIntegrationAsync()
    ;
  const {
    mutateAsync: mutateDeleteHomeAssistantIntegrationAsync,
    isLoading: isLoadingDeleteHomeAssistantIntegrationAsync,
  } = useDeleteHomeAssistantIntegrationAsync();
  const {
    mutateAsync: mutateDeleteMoovsecIntegrationAsync,
    isLoading: isLoadingDeleteMoovsecIntegrationAsync,
  } = useDeleteMoovsecIntegrationAsync();
  const {
    mutateAsync: mutateDeleteSevenEduIntegrationAsync,
    isLoading: isLoadingDeleteSevenEduIntegrationAsync,
  } = useDeleteSevenEduIntegrationAsync();
  const {
    mutateAsync: mutateDeleteSponteIntegrationAsync,
    isLoading: isLoadingDeleteSponteIntegrationAsync,
  } = useDeleteSponteIntegrationAsync();
  const {
    mutateAsync: mutateDeleteEscolaWebIntegrationAsync,
    isLoading: isLoadingDeleteEscolaWebIntegrationAsync,
  } = useDeleteEscolaWebIntegrationAsync();
  const {
    mutateAsync: mutateDeleteEscolarManagerIntegrationAsync,
    isLoading: isLoadingDeleteEscolarManagerIntegrationAsync,
  } = useDeleteEscolarManagerIntegrationAsync();
  const columns: IColumnProps[] = [
    {
      id: 'discriminator',
      label: t('integrationsPage.tableColumns.type'),
      width: '0%',
      align: 'center',
      render: (val: any, rowIndex: number, row?: any) => {
        const icon = renderIconByIntegrationType(val);
        const isActive = row?.isActive ?? true;
        return (
          <MuiBadge
            variant="dot"
            color={isActive ? 'success' : 'error'}
            overlap="circular"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
          >
            {icon}
          </MuiBadge>
        );
      },
    },
    {
      id: 'name',
      label: t('integrationsPage.tableColumns.name'),
      width: '50%',
    },
    {
      id: 'description',
      label: t('integrationsPage.tableColumns.description'),
      width: '100%',
    },
    {
      id: 'id',
      label: t('integrationsPage.tableColumns.actions'),
      align: 'center',
      width: 'min',
      render: (id, rowIndex: number, row?: any) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          handleDelete={() => {
            const integration = integrations.find(int => int.id === Number(id));
            setSelectedItem(integration);
            setIsVisibleDeleteItemModal(true);
          }}
          handleEdit={() => {
            const integration = integrations.find(int => int.id === Number(id));
            setSelectedItem(integration);
            setIsVisibleEditionModal(true);
          }}
        />
      ),
    },
  ];

  const additionalComponent = () => {
    return (
      <ButtonComponent onClick={handleModalEdition}>
        {t('integrationsPage.newIntegration')}
      </ButtonComponent>
    );
  };

  const handleModalEdition = () => {
    setIsVisibleEditionModal(true);
  };

  const renderIconByIntegrationType = (val: IntegrationDiscriminator) => {
    switch (val) {
      case 'CigamEntity':
        return <IconImageComponent src={cigam_icon} width={24} height={24} />;
      case 'MoniEntity':
        return <IconImageComponent src={moni_icon} width={24} height={24} />;
      case 'SurgardEntity':
        return <LockReset color="success" />;
      case 'WebhookEntity':
        return <Webhook color="primary" />;
      case 'SigmaEntity':
        return <IconImageComponent src={sigma_icon} width={24} height={24} />;
      case 'DefenseEntity':
        return <Shield width={3} height={3} />;
      case 'DefenseBridgeEntity':
        return <Route width={3} height={3} />;
      case 'ClassAppEntity':
        return <IconImageComponent src={classapp_icon} width={24} height={24} />;
      case 'GvdasaEntity':
        return <IconImageComponent src={gvdasa_icon} width={24} height={24} />;
      case 'ActiveSoftEntity':
        return <IconImageComponent src={activesoft_icon} width={24} height={24} />;
      case 'TuyaEntity':
        return <IconImageComponent src={tuya_icon} width={24} height={24} />;
      case 'TotvsEntity':
        return <IconImageComponent src={totvs_logo} width={24} height={24} />;
      case 'HomeAssistantEntity':
        return <Home color="primary" />;
      case 'SmtpEntity':
        return <Mail />;
      case 'TotvsIENHEntity':
        return <IconImageComponent src={totvs_logo} width={24} height={24} />;
      case 'MoovsecEntity':
        return <IconImageComponent src={moovsec_icon} width={24} height={24} />;
      case 'SevenEduEntity':
        return <IconImageComponent src={sevenedu_icon} width={24} height={24} />;
      case 'SponteEntity':
        return <IconImageComponent src={sponte_icon} width={24} height={24} />;
      case 'EscolaWebEntity':
        return <IconImageComponent src={escolaweb_icon} width={24} height={24} />;
      case 'EscolarManagerEntity':
        return <IconImageComponent src={escolarmanager_icon} width={24} height={24} />;
      case 'ClipEscolaEntity':
        return <IconImageComponent src={clipescola_icon} width={24} height={24} />;
      case 'SophiaEntity':
        return <IconImageComponent src={sophia_icon} width={24} height={24} />;
    }
    return <></>;
  };

  const handleCancelDeletion = () => {
    setIsVisibleDeleteItemModal(false);
    setSelectedItem(undefined);
  };

  const handleConfirmDeletion = async () => {
    if (selectedItem?.id) {
      switch (selectedItem.discriminator) {
        case 'SurgardEntity':
          await mutateDeleteSurgardIntegrationAsync(selectedItem?.id);
          break;
        case 'WebhookEntity':
          await mutateDeleteWebhookIntegrationAsync(selectedItem?.id);
          break;
        case 'MoniEntity':
          await mutateDeleteMoniIntegrationAsync(selectedItem?.id);
          break;
        case 'DefenseEntity':
          await mutateDeleteDefenseIntegrationAsync(selectedItem?.id);
          break;
        case 'SigmaEntity':
          await mutateDeleteSigmaIntegrationAsync(selectedItem?.id);
          break;
        case 'DefenseBridgeEntity':
          await mutateDeleteDefenseBridgeIntegrationAsync(selectedItem?.id);
          break;
        case 'ClassAppEntity':
          await mutateDeleteClassAppIntegrationAsync(selectedItem?.id);
          break;
        case 'GvdasaEntity':
          await mutateDeleteGvdasaIntegrationAsync(selectedItem?.id);
          break;
        case 'ActiveSoftEntity':
          await mutateDeleteActiveSoftIntegrationAsync(selectedItem?.id);
          break;
        case 'SmtpEntity':
          await mutateDeleteSmtpIntegrationAsync(selectedItem?.id);
          break;
        case 'ClipEscolaEntity':
          await mutateDeleteClipEscolaIntegrationAsync(selectedItem?.id);
          break;
        case 'SophiaEntity':
          await mutateDeleteSophiaIntegrationAsync(selectedItem?.id);
          break;
        case 'CigamEntity':
          await mutateDeleteCigamIntegrationAsync(selectedItem?.id);
          break;
        case 'TuyaEntity':
          await mutateDeleteTuyaIntegrationAsync(selectedItem?.id);
          break;
        case 'TotvsEntity':
          await mutateDeleteTotvsIntegrationAsync(selectedItem?.id);
          break;
        case 'HomeAssistantEntity':
          await mutateDeleteHomeAssistantIntegrationAsync(selectedItem?.id);
          break;
        case 'TotvsIENHEntity':
          await mutateDeleteTotvsIENHIntegrationAsync(selectedItem?.id);
          break;
        case 'MoovsecEntity':
          await mutateDeleteMoovsecIntegrationAsync(selectedItem?.id);
          break;
        case 'SevenEduEntity':
          await mutateDeleteSevenEduIntegrationAsync(selectedItem?.id);
          break;
        case 'SponteEntity':
          await mutateDeleteSponteIntegrationAsync(selectedItem?.id);
          break;
        case 'EscolaWebEntity':
          await mutateDeleteEscolaWebIntegrationAsync(selectedItem?.id);
          break;
        case 'EscolarManagerEntity':
          await mutateDeleteEscolarManagerIntegrationAsync(selectedItem?.id);
          break;
      }
    }
    resetAll();
    showSnackbar('Integração excluída com sucesso.', 'success');
    reqAllIntegrations();
  };

  const reqAllIntegrations = () =>
    mutateGetAllIntegrationsByLicenseAsync().then(setIntegrations);

  const handleCloseEdition = () => {
    resetAll();
    reqAllIntegrations();
  };

  const resetAll = () => {
    setSelectedItem(undefined);
    setIsVisibleEditionModal(false);
    setIsVisibleDeleteItemModal(false);
    setIntegrationEditModalKey(Math.random() * 20);
  };

  useEffect(() => {
    reqAllIntegrations();
  }, []);
  return (
    <>
      <HeaderDashboard></HeaderDashboard>
      <TableComponent
        rows={integrations}
        sortByName={'name'}
        additionalTitleComponent={additionalComponent()}
        columns={columns}
        defaultOrder={'asc'}
        title={t('integrationsPage.title')}
      />

      <IntegrationEditModal
        key={integrationEditModalKey}
        isOpen={isVisibleEditionModal}
        renderIconByIntegrationType={renderIconByIntegrationType}
        handleClose={handleCloseEdition}
        integrationSelected={selectedItem}
      />

      <ConfirmDeleteModalComponent
        isLoading={
          isLoadingDeleteMoniIntegrationAsync ||
          isLoadingDeleteWebhookIntegrationAsync ||
          isLoadingDeleteDefenseIntegrationAsync ||
          isLoadingDeleteSigmaIntegrationAsync ||
          isLoadingDeleteSurgardIntegrationAsync ||
          isLoadingDeleteDefenseBridgeIntegrationAsync ||
          isLoadingDeleteClipEscolaIntegrationAsync ||
          isLoadingDeleteCigamIntegrationAsync ||
          isLoadingDeleteSophiaIntegrationAsync ||
          isLoadingDeleteSmtpIntegrationAsync ||
          isLoadingDeleteActiveSoftIntegrationAsync ||
          isLoadingDeleteGvdasaIntegrationAsync ||
          isLoadingDeleteClassAppIntegrationAsync ||
          isLoadingDeleteTuyaIntegrationAsync ||
          isLoadingDeleteTotvsIntegrationAsync ||
          isLoadingDeleteHomeAssistantIntegrationAsync ||
          isLoadingDeleteMoovsecIntegrationAsync ||
          isLoadingDeleteTotvsIENHIntegrationAsync ||
          isLoadingDeleteSevenEduIntegrationAsync ||
          isLoadingDeleteSponteIntegrationAsync ||
          isLoadingDeleteEscolaWebIntegrationAsync ||
          isLoadingDeleteEscolarManagerIntegrationAsync
        }
        isVisibleDeleteDialog={isVisibleDeleteItemModal}
        setIsVisibleDeleteDialog={setIsVisibleDeleteItemModal}
        title={'Excluir Integração'}
        message={`Tem certeza que deseja excluir a integração "${selectedItem?.name}"?`}
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
      />
    </>
  );
}

export default IntegrationPage;
